var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9457 1.55123L14.9458 1.55116C15.0197 1.37032 14.9781 1.16305 14.8448 1.02171L14.8448 1.02168L14.8422 1.01908C14.7042 0.881014 14.5 0.835796 14.3164 0.90516L14.3164 0.905153L14.3151 0.905652L1.06133 6.0797L1.06124 6.07974C0.87381 6.15308 0.74649 6.33634 0.750073 6.54193C0.750596 6.74248 0.876904 6.92615 1.06623 6.99625C1.06632 6.99629 1.06642 6.99632 1.06651 6.99636L6.60568 9.07431L8.73469 14.4738C8.73471 14.4739 8.73474 14.4739 8.73476 14.474C8.80836 14.6619 8.98855 14.785 9.18953 14.785H9.19258C9.39113 14.785 9.57218 14.6673 9.64683 14.4814C9.64691 14.4812 9.64699 14.481 9.64707 14.4808L14.9457 1.55123ZM7.55877 8.81615L13.141 3.37121L9.20094 12.9804L7.55877 8.81615ZM6.86323 8.12449L2.61202 6.52923L12.4214 2.70062L6.86323 8.12449Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.25783981.svg";
export { ForwardRef as ReactComponent };